import type { FC, ImgHTMLAttributes, ReactNode } from 'react';
import { LazyLoadImage as LazyLoadImageBase } from 'react-lazy-load-image-component';

type LazyLoadImageProps = Omit<
  ImgHTMLAttributes<HTMLImageElement>,
  'src' | 'alt' | 'loading'
> & {
  src?: string | null;
  alt?: string | null;
  loading?: 'eager' | 'lazy';
  visibleByDefault?: boolean;
  afterLoad?: () => void;
  beforeLoad?: () => void;
  delayMethod?: string;
  delayTime?: number;
  effect?: string;
  placeholder?: ReactNode;
  placeholderSrc?: string | null;
  threshold?: number;
  useIntersectionObserver?: boolean;
  wrapperClassName?: string;
  wrapperProps?: object;
};

const LazyLoadImageBaseTyped = LazyLoadImageBase as FC<LazyLoadImageProps>;

export const LazyLoadImage: FC<LazyLoadImageProps> = ({
  visibleByDefault,
  loading,
  ...rest
}) => (
  <LazyLoadImageBaseTyped
    {...rest}
    visibleByDefault={visibleByDefault}
    loading={loading ?? (visibleByDefault ? undefined : 'lazy')}
  />
);
